var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _vm.currentUserIsOrganizationAdmin &&
    _vm.currentUserOrganizationUnitId == _vm.organizationUnitId
      ? _c(
          "div",
          {
            staticStyle: { "padding-top": "80px" },
            attrs: { id: "navigationPlaceholder" },
          },
          [
            _vm.organizationUnitId
              ? _c("AdminNavigationV2", {
                  attrs: { tid: _vm.organizationUnitId },
                })
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-7" }, [
          _c(
            "h1",
            {
              staticStyle: {
                "font-size": "2em",
                "font-weight": "300",
                color: "#33475b",
              },
            },
            [_vm._v("Manage user's roles")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-link btn-sm",
              on: {
                click: function ($event) {
                  return _vm.$router.go(-1)
                },
              },
            },
            [
              _c("i", {
                staticClass: "fa fa-arrow-left",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Back")]),
            ]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("hr", {
      staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
    }),
    _vm._v(" "),
    _vm.id && _vm.user
      ? _c("div", { staticClass: "container" }, [
          _c("h4", { staticClass: "fg-color-blue" }, [
            _vm._v(
              _vm._s(_vm.displayName) +
                " is currently " +
                _vm._s(_vm.roles.join(", "))
            ),
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _vm.currentUserIsSystemAdmin || _vm.currentUserIsGlobalAdmin
              ? _c("div", { staticClass: "col-sm-4" }, [
                  _c(
                    "div",
                    {
                      staticClass: "card text-white",
                      class: [
                        _vm.isGlobalAdmin ? "bg-primary" : "bg-secondary",
                      ],
                    },
                    [
                      _c("div", { staticClass: "card-header" }, [
                        _vm._v("Global Admin"),
                      ]),
                      _vm._v(" "),
                      _vm._m(0),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-footer text-center" }, [
                        !_vm.isGlobalAdmin
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-light",
                                attrs: { type: "button" },
                                on: {
                                  click:
                                    _vm.handleAssignGlobalAdminRoleCommandV1,
                                },
                              },
                              [_vm._v("Assign Global Admin")]
                            )
                          : _c(
                              "button",
                              {
                                staticClass: "btn btn-light",
                                attrs: { type: "button" },
                                on: {
                                  click:
                                    _vm.handleRevokeGlobalAdminRoleCommandV1,
                                },
                              },
                              [_vm._v("Revoke Global Admin")]
                            ),
                      ]),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.currentUserIsSystemAdmin ||
            _vm.currentUserIsGlobalAdmin ||
            _vm.currentUserIsOrganizationAdmin
              ? _c("div", { staticClass: "col-sm-4" }, [
                  _c(
                    "div",
                    {
                      staticClass: "card text-white",
                      class: [
                        _vm.isOrganizationAdmin ? "bg-primary" : "bg-secondary",
                      ],
                    },
                    [
                      _c("div", { staticClass: "card-header" }, [
                        _vm._v("Organization Admin"),
                      ]),
                      _vm._v(" "),
                      _vm._m(1),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-footer text-center" }, [
                        !_vm.isOrganizationAdmin
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-light",
                                attrs: { type: "button" },
                                on: {
                                  click:
                                    _vm.handleAssignOrganizationAdminRoleCommandV1,
                                },
                              },
                              [_vm._v("Assign Organization Admin")]
                            )
                          : _c(
                              "button",
                              {
                                staticClass: "btn btn-light",
                                attrs: { type: "button" },
                                on: {
                                  click:
                                    _vm.handleRevokeOrganizationAdminRoleCommandV1,
                                },
                              },
                              [_vm._v("Revoke Organization Admin")]
                            ),
                      ]),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.currentUserIsSystemAdmin || _vm.currentUserIsOrganizationAdmin
              ? _c("div", { staticClass: "col-sm-4" }, [
                  _c(
                    "div",
                    {
                      staticClass: "card text-white",
                      class: [
                        _vm.isWorkspaceUser ? "bg-primary" : "bg-secondary",
                      ],
                    },
                    [
                      _c("div", { staticClass: "card-header" }, [
                        _vm._v("Workspace User"),
                      ]),
                      _vm._v(" "),
                      _vm._m(2),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-footer text-center" }, [
                        !_vm.isWorkspaceUser
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-light",
                                attrs: { type: "button" },
                                on: {
                                  click:
                                    _vm.handleAssignWorkspaceUserRoleCommandV1,
                                },
                              },
                              [_vm._v("Assign Workspace User")]
                            )
                          : _c(
                              "button",
                              {
                                staticClass: "btn btn-light",
                                attrs: { type: "button" },
                                on: {
                                  click:
                                    _vm.handleRevokeWorkspaceUserRoleCommandV1,
                                },
                              },
                              [_vm._v("Revoke Workspace User")]
                            ),
                      ]),
                    ]
                  ),
                ])
              : _vm._e(),
          ]),
        ])
      : !_vm.id
      ? _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "input-group mb-3" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.emailinput,
                  expression: "emailinput",
                },
              ],
              staticClass: "form-control",
              attrs: { type: "email", placeholder: "Find user by email" },
              domProps: { value: _vm.emailinput },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.emailinput = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "input-group-append" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-secondary",
                  attrs: { type: "button" },
                  on: { click: _vm.handleFindUser },
                },
                [_vm._v("Find")]
              ),
            ]),
          ]),
        ])
      : _c("div", { staticClass: "container" }, [
          _c("h4", [_vm._v("Email '" + _vm._s(_vm.id) + "' not found")]),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "card-body" }, [
      _c("p", { staticClass: "card-text", staticStyle: { height: "200px" } }, [
        _vm._v(
          "\n                            Users in this role have an access to admin panel and can set up organizations. They permissions include:\n                            "
        ),
        _c("ul", [
          _c("li", [_vm._v("Setting up a new organizations")]),
          _vm._v(" "),
          _c("li", [_vm._v("Assign global admins")]),
          _vm._v(" "),
          _c("li", [_vm._v("Assign organization admins")]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "card-body" }, [
      _c("p", { staticClass: "card-text", staticStyle: { height: "200px" } }, [
        _vm._v(
          "\n                            Users in this role have an access to admin panel and can manage within a single organizations. They permissions include:\n                            "
        ),
        _c("ul", [
          _c("li", [_vm._v("Managing users")]),
          _vm._v(" "),
          _c("li", [_vm._v("Managing workspaces")]),
          _vm._v(" "),
          _c("li", [_vm._v("Importing portfolios")]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "card-body" }, [
      _c("p", { staticClass: "card-text", staticStyle: { height: "200px" } }, [
        _vm._v(
          "\n                            Users in this role have an access to workspaces and its portfolios. They permissions include:\n                            "
        ),
        _c("ul", [
          _c("li", [_vm._v("Creating a new portfolios")]),
          _vm._v(" "),
          _c("li", [_vm._v("Managing projects")]),
          _vm._v(" "),
          _c("li", [_vm._v("Managing criteria")]),
          _vm._v(" "),
          _c("li", [_vm._v("Managing surveys")]),
          _vm._v(" "),
          _c("li", [_vm._v("Browsing results")]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }